import { Observable } from 'rxjs';
import { UserDTO, UserRequestDTO } from '../../data/dto/UserDTO';

export abstract class UserRepository {
    abstract login(request: UserRequestDTO): Observable<UserDTO>;
}